import { render, staticRenderFns } from "./AppContactsActions.vue?vue&type=template&id=5b12066f"
import script from "./AppContactsActions.vue?vue&type=script&lang=js"
export * from "./AppContactsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports